import React from 'react';
import { protect, service, site, host, develope } from './imports';
import './brand.css';

const Brand = () => (
    <div className="sam__brand section__padding">
        <div>
            <img src={protect} />
        </div>
        <div>
            <img src={service} />
        </div>
        <div>
            <img src={site} />
        </div>
        <div>
            <img src={host} />
        </div>
        <div>
            <img src={develope} />
        </div>
    </div>
);

export default Brand;
